import { render, staticRenderFns } from "./phoneUnbound.vue?vue&type=template&id=32136728&scoped=true"
import script from "./phoneUnbound.vue?vue&type=script&lang=js"
export * from "./phoneUnbound.vue?vue&type=script&lang=js"
import style0 from "./phoneUnbound.vue?vue&type=style&index=0&id=32136728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32136728",
  null
  
)

export default component.exports